export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./last-winnings.vue?vue&type=template&id=29ff1ca5"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/last-winnings/last-winnings.vue?vue&type=template&id=29ff1ca5
// module id = DoXV
// module chunks = 0